import React, { useState } from "react";
import OTPInput from "react-otp-input";

const OtpEmail = ({
  id_R,
  otpEmailOpen,
  setOtpEmailOpen,
  otp,
  setOtp,
  handleOtpVerification,
  setIsNewEmailOpen,
  newEmail,
}) => {
  const [isOtpValid, setIsOtpValid] = useState(false);

  const handleClose = () => {
    setOtpEmailOpen(false);
  };

  const handleOtpChange = (newOtp) => {
    setOtp(newOtp);
    setIsOtpValid(newOtp.length === 6);
  };

  const handleBackButton = () => {
    handleClose();
    setIsNewEmailOpen(true);
  };

  return (
    <>
      <div
        id={id_R}
        className={`${
          otpEmailOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto w-[60vw]">
            <div
              onClick={handleClose}
              className="absolute top-[5px] right-[10px] cursor-pointer text-[24px] flex items-center justify-center"
            >
              X
            </div>
            <div className="p-[20px]">
              <div className="flex items-center">
                <p className="text-[20px] font-bold text-[#000] mt-8">
                  Verify email
                </p>
              </div>
              <p className="text-[#000] text-[15px] mt-3">
                Enter OTP code sent to the email you entered.
              </p>
              <div className="flex flex-col items-center h-[65vh] mt-20">
                <p className="text-[#000] font-[300] text-[15px]">
                  An OTP has been sent to the email: {newEmail}
                </p>
                <div className="flex flex-col mt-20">
                  <label
                    htmlFor="firstname"
                    className="mb-[20px] text-[#000000] font-[500]"
                  >
                    Email verification OTP
                  </label>
                  <div className="flex items-center gap-[10px]">
                    <div>
                      <OTPInput
                        value={otp}
                        onChange={handleOtpChange}
                        numInputs={6}
                        onPaste={true}
                        renderInput={(props) => (
                          <input
                            {...props}
                            style={{ width: "45px", height: "45px" }}
                          />
                        )}
                        renderSeparator={<span className="mx-2" />}
                        inputStyle="bg-white text-[20px] text-center text-[24px] text-[#000] border-[1px] border-[#000] rounded-[5px]"
                      />
                    </div>
                  </div>
                </div>
                <div className="flex items-end w-full mx-auto h-[35vh] text-white justify-between">
                  <button
                    onClick={handleBackButton}
                    className="h-[50px] w-[175px] bg-[#8ED6A8] rounded-[5px] text-[#000]"
                  >
                    Back
                  </button>
                  <button
                    onClick={handleOtpVerification}
                    className={`h-[50px] w-[175px] rounded-[5px] transition-all duration-200 ${
                      isOtpValid
                        ? "bg-[#005C53] cursor-pointer"
                        : "bg-[#D9D9D9] cursor-not-allowed"
                    }`}
                    disabled={!isOtpValid}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OtpEmail;
